import { Injectable } from '@angular/core';
import { ProductListComponentService, ProductListRouteParams } from '@spartacus/storefront';
@Injectable({ providedIn: 'root' })
export class GgProductListComponentService extends ProductListComponentService {
  protected readonly PRICE_DESC_ALLCATEGORIES = '::allCategories:';

  protected override getQueryFromRouteParams({ query, categoryCode, brandCode }: ProductListRouteParams) {
    if (query) {
      return query;
    }
    if (categoryCode) {
      return this.PRICE_DESC_ALLCATEGORIES + categoryCode;
    }

    // TODO: drop support for brands as they should be treated
    // similarly as any category.
    if (brandCode) {
      return this.PRICE_DESC_ALLCATEGORIES + brandCode;
    }

    return ':allCategories';
  }
}
